import { classNames } from 'libs/react';
import { named } from 'libs/react';
import { Error } from 'components/Error';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { Waiter } from 'components/Waiter';
import { React } from 'libs/react';
import './Pane.scss';
/**
 * @component Pane
 * @since 1.0.0
 */
export function Pane(props) {
    const { name, style, ready, error, minimumLoadingTime, maximumLoadingTime } = Object.assign({ style: 'normal', ready: true, minimumLoadingTime: 0, maximumLoadingTime: 5000 }, props);
    const className = classNames('pane', 'pane--' + style, props.className, named('pane', name));
    return (React.createElement("div", { className: className },
        React.createElement(Waiter, { until: ready, renderWhileLoading: false, minimumLoadingTime: minimumLoadingTime, maximumLoadingTime: maximumLoadingTime },
            React.createElement(When, null,
                React.createElement(Case, { is: error },
                    React.createElement(Error, { title: "Ooops!", infos: "An error occured while trying to perform an action.", picto: "fal bug", error: error })),
                React.createElement(Else, null, props.children)))));
}
